import {
	ReactNode,
	createContext,
	useContext,
	useEffect,
	useState,
	useMemo,
} from "react"
import { useSearchParams, useLocation, useNavigate } from "@/lib/router"

const HiddenGetParamsContext = createContext<HiddenGetParamsContextType>(null!)

/**
 * MangoPay SCA ControlStatusEnum
 *
 * TODO: The following state is also possible but not documented: PENDING_VALIDATION
 * DOCS: https://docs.mangopay.com/guides/sca/session#6-receive-the-user-on-return
 */
export enum ControlStatusEnum {
	VALIDATED = "VALIDATED",
	FAILED = "FAILED",
}

export type ControlStatus = ControlStatusEnum
interface HiddenGetParamsContextType {
	next?: string
	controlStatus?: ControlStatus
}

export const useHiddenGetParamsContext = () =>
	useContext(HiddenGetParamsContext)

/**
 * HiddenGetParamsProvider
 * @param param0
 * @returns
 */
export function HiddenGetParamsProvider({ children }: { children: ReactNode }) {
	// Router
	const location = useLocation()
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()

	// Params that we can capture
	const [nextGetParam, setNextGetParam] = useState<string>()
	const [controlStatusParam, setControlStatusParam] =
		useState<ControlStatus>()

	// When we have get params
	useEffect(() => {
		// Hide 'next' param from and store in context
		let nextGetParam = searchParams.get("next")?.replace(/^\/|$/g, "")
		if (nextGetParam) {
			setNextGetParam(nextGetParam)
			navigate(location.pathname)
		}

		// Hide 'control_status' param from and store in context
		let controlStatusParam = searchParams
			.get("controlStatus")
			?.replace(/^\/|$/g, "")
		if (controlStatusParam) {
			setControlStatusParam(controlStatusParam as ControlStatus)
			navigate(location.pathname)
		}
	}, [searchParams, location, navigate])

	return (
		<HiddenGetParamsContext.Provider
			value={{
				next: nextGetParam,
				controlStatus: controlStatusParam,
			}}
		>
			{useMemo(() => children, [children])}
		</HiddenGetParamsContext.Provider>
	)
}
